import { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import NotFoundPage from '../pages/notFound/notFound';

import { MAX_WIDTH_CONTAINER_NotImprotant } from '../config/cacheKey';
import Maintenance from '../pages/maintenance/maintenance';
import RouteWithState from '../routeWithState/routeWithState';
import ExternalRoute from '../pages/externalRoute/externalRoute';
import NotFountNew from '../pages/notFound/notFountNew';

export default function BasePage() {
    const environment = process.env.REACT_APP_ENV;

    // useEffect(() => {
    //     if (screen.orientation && (screen.orientation as any).lock) {
    //         (screen.orientation as any).lock('portrait').catch((err: any) => {
    //             console.error("Cannot lock orientation:", err);
    //         });
    //     }
    // }, []);

    return (
        <>
            {environment !== 'prod' && (
                <div style={{
                    position: 'fixed',
                    top: '0px',
                    left: 0,
                    right: 0,
                    backgroundColor: 'rgba(255, 0, 0, 0.7)',
                    color: '#fff',
                    zIndex: '1200000',
                    direction: 'rtl',
                    fontWeight: 'bold',
                    textAlign: 'center',
                    padding: '0',
                    // maxWidth: MAX_WIDTH_CONTAINER_NotImprotant,
                    margin: 'auto'
                }}>
                    محیط تست
                </div>
            )}
            <Routes>
                <Route>
                    <Route path="/app" element={<RouteWithState />} />
                    <Route path="/" element={<RouteWithState />} />
                    {/* Add the "ONGOINGDETAILPURCHASE" route if necessary; otherwise, it can be removed. (todo) */}
                    <Route path="/ONGOINGDETAILPURCHASE/:key" element={<RouteWithState />} />
                    <Route path="/maintenance" element={<Maintenance message='مشکلی رخ داده است' />} />
                    <Route path="/externalRoute" element={<ExternalRoute message='مشکلی رخ داده است' />} />
                </Route>
                <Route path="*" element={<NotFountNew message='مشکلی رخ داده است' description='صفحه ای که به دنبال آن هستید یافت نشد!' />} />
            </Routes>
        </>
    );
}
